<template>
    <div>
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            {{ $t('auth.twoFactorSetup.pageTitle') }}
        </h2>

        <p class="mt-6 flex flex-col items-center justify-between text-sm leading-5">
            {{ $t('auth.twoFactorSetup.instructions') }}
        </p>

        <div class="flex flex-col mt-6">
            <apexo-button @click="enableTwoFactorAuthentication">
                {{ $t('auth.twoFactorSetup.activate') }}
            </apexo-button>

            <a class="text-center text-sm text-blue-400 mt-2 cursor-pointer" @click="goToOrders">
                {{ $t('auth.twoFactorSetup.later') }}
            </a>
        </div>

        <two-factor-setup-modal @closed="goToOrders" />
    </div>
</template>

<script>
    import TwoFactorSetupModal from '@/components/Auth/TwoFactorSetupModal.vue';
    import ApexoButton from '../../components/Elements/ApexoButton.vue';

    export default {
        components: { TwoFactorSetupModal, ApexoButton },

        methods: {
            async enableTwoFactorAuthentication() {
                try {
                    await this.$axios.post('/user/two-factor-authentication');

                    const qrCodeResponse = await this.$axios.get('/user/two-factor-qr-code');
                    const recoveryCodesResponse = await this.$axios.get('/user/two-factor-recovery-codes');

                    this.$modal.open('two-factor-setup', {
                        qrCode: qrCodeResponse.data.svg,
                        recoveryCodes: recoveryCodesResponse.data,
                    });
                } catch (error) {
                    console.log(error);
                    this.$axios.delete('/user/two-factor-authentication');
                }
            },

            goToOrders() {
                this.$router.replace({ name: 'orders' });
            },
        },
    };
</script>
